<template>
  <permission-section-card :fixedHeight="false">
    <!-- card title -->
    <div slot="title">
      <div class="row">
        <div class="col-md-6">
          <h3 class="pull-left">&nbsp;Profiles Filter</h3>
        </div>
        <!-- search field -->
        <div>
          <identifier-filter
            ref="identifier"
            class="pull-right"
            style="margin-right: 10px"
            @search-profile="$emit('search-profile', $event)"
            :loading="loadingProfile"
          />
        </div>
      </div>
    </div>
    <!-- card description -->
    <div slot="description">
      Utilize the search functionality to identify the target profile
    </div>
    <!-- card content -->
    <div slot="content">
      <permission-profile-browser
        v-if="!displayProfile"
        :profiles="results.profiles"
        :filtered-total="results.filteredTotal"
        :loadingProfile="loadingProfile"
      />
    </div>

  </permission-section-card>
</template>

<script>
import { get } from 'lodash';
import PermissionSectionCard from '@/components/permission/PermissionSectionCard';
import PermissionProfileBrowser from '@/components/permission/PermissionProfileBrowser';
import IdentifierFilter from '@/components/permission/filters/IdentifierFilter';

export default {
  name: 'PermissionFilterCard',
  components: {
    PermissionSectionCard,
    IdentifierFilter,
    PermissionProfileBrowser,
  },
  data: () => ({
    profile: [],
    query: { identifier: '' },
    displayProfile: false,
  }),
  props: {
    results: {
      type: Object,
      required: true,
    },
    loadingProfile: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    get,
    handleDisplayProfile() {
      this.displayProfile = !this.displayProfile;
      this.$emit('display-profile');
    },
  },
};
</script>


// WEBPACK FOOTER //
// PermissionFilterCard.vue?c8f5269e